import styled from 'styled-components';

import { styledMedia, styledTypography } from '@pkg/primitives';

import { tokens } from './AssetHistoryStatus.tokens';

export const StyledAssetHistoryStatus = styled.div`
    display: grid;
    grid-auto-flow: column;
    align-content: center;
    justify-content: start;
    gap: ${tokens.status.gap}px;
`;

export const IconWrapper = styled.div`
    ${styledMedia.iconWrapper};
    width: ${tokens.status.iconSize}px;
    height: ${tokens.status.iconSize}px;
`;

export const Label = styled.p`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    font-size: ${tokens.status.labelSize}px;
    font-weight: 600;
    letter-spacing: -0.02em;
`;
